import AxiosClient from "../../../services/axios.services";

class ExperienceServices {
  getExperience = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_experiencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getExperienceById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_experiencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  saveExperience = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_experiencia/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editExperience = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_experiencia/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteExperience = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_experiencia/${id}`, {
      headers: { "Content-Type": "aplication/json" },
    });
}

export default new ExperienceServices();
